import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import CustomDialog from '../custom-material/dialog/Dialog'
import CustomDialogTitle from '../custom-material/dialog/DialogTitle'
import { OkDialogButton } from '../custom-material/button/Button'
import CustomTypography from '../custom-material/typography/Typography'

const styles = theme => ({
  dialog: {
    maxWidth: 400
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 16
  },
  fieldRowContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12
  },
  fieldColumnContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: 12
  },
  fieldRowLabel: {
    marginRight: 8
  },
  fieldColumnLabel: {
    marginBottom: 8
  },
  input: {
    fontSize: '1em',
    border: '1px solid rgba(0, 0, 0, 0.42)',
    borderBottom: 0,
    borderRadius: 2,
    marginTop: '28px !important'
  },
  inputText: {
    paddingLeft: 3
  },
  inputShrinkLabel: {
    color: 'black',
    fontWeight: 600,
    fontSize: '1.42em'
  },
  actionContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 12
  }
})

const RequestEmailConfirmDialogComponent = ({ classes, dialogOpen, handleCloseDialog }) => (
  <CustomDialog classes={{paper: classes.dialog}} open={dialogOpen} onClose={handleCloseDialog} aria-labelledby='updates-dialog-title'>
    <CustomDialogTitle id='updates-dialog-title' disableTypography>Request Email Edit</CustomDialogTitle>
    <div className={classes.contentContainer}>
      <div className={classes.fieldRowContainer}>
        <CustomTypography align='center'>
          Thank you!<br />
          You have successfully requested a change to your email address.
        </CustomTypography>
      </div>
      <div className={classes.fieldRowContainer}>
        <CustomTypography align='center'>
          Please continue to use your previous email address (or username) to login until you have received confirmation of the change.
        </CustomTypography>
      </div>
      <div className={classes.actionContainer}>
        <OkDialogButton variant='contained' size='small' color='secondary'  onClick={handleCloseDialog}>Close</OkDialogButton>
      </div>
    </div>
  </CustomDialog>
)

RequestEmailConfirmDialogComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogOpen: PropTypes.bool,
  handleCloseDialog: PropTypes.func
}

export default withStyles(styles)(RequestEmailConfirmDialogComponent)
